import React, { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import UesrContext from '../../contexts/user-context/UserProvider';
import customHistory from '../../history';
import FlashMessageContext from '../../contexts/flash-messages-context/FlashMessageProvider';
import DocTitleScrollTop from '../../utils/DocTitleScrollTop';
import PostForm from './PostForm';
import { useParams } from 'react-router-dom';
import ContentLoader from 'react-content-loader';
import pickSkeletonColor from '../../utils/pickSkeletonColor';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';

const EditPost = ({ post }) => {
	DocTitleScrollTop('Create Post');
	const sleep = ms => new Promise(r => setTimeout(r, ms));
	const {
		user: { token, username }
	} = useContext(UesrContext);
	const { themeName } = useContext(MyThemeContext);
	const {
		setFlashMsgIsOpen,
		setFlashMsg,
		setFlashMsgDuration,
		setNotificationSeverity
	} = useContext(FlashMessageContext);

	const { postId } = useParams();
	const [postFetched, setPostFetched] = useState(null);

	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();

		const fetchPost = async id => {
			await sleep(500);
			try {
				const response = await Axios.get(`/post/${id}`, {
					cancelToken: cancelTokenSource.token
				});
				console.log('fetched post', response);
				// check if status is ok and we have data and the same logged in user is the outher of this post
				if (
					response.status === 200 &&
					response.data &&
					response.data.author.username === username
				) {
					setPostFetched(response.data);
				}
				// check if the user is trying to edit this post is not the author of the post
				else if (
					response.status === 200 &&
					response.data &&
					response.data.author.username !== username
				) {
					setFlashMsgIsOpen(true);
					setFlashMsg('You do not have permission to edit this post!');
					setFlashMsgDuration(4000);
					setNotificationSeverity('error');
					customHistory.push('/');
				} else {
					customHistory.push('/notfound');
				}
			} catch (e) {
				if (Axios.isCancel(e)) {
					console.log('Cought cancel');
				} else {
					throw e;
				}
			}
		};
		fetchPost(postId);

		// cleanup
		return () => {
			cancelTokenSource.cancel();
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handleFormSubmit = async (values, { setSubmitting, resetForm }) => {
		// await sleep(500);
		try {
			const { post_title, post_body } = values;
			setSubmitting(true);
			const response = await Axios.post(`post/${postId}/edit`, {
				title: post_title,
				body: post_body,
				token
			});
			if (response.status === 200 && response.data === 'success') {
				setSubmitting(false);
				setFlashMsgIsOpen(true);
				setFlashMsg('Edited Post Successfully!');
				setFlashMsgDuration(4000);
				setNotificationSeverity('success');
				resetForm();
				customHistory.push(`/post/${postId}`);
			}
		} catch (e) {
			setSubmitting(false);
			setFlashMsgIsOpen(true);
			setFlashMsg(e.message);
			setFlashMsgDuration(4000);
			setNotificationSeverity('error');
		}
	};
	return (
		<div className="myPage createPostPage">
			<div className="mfaContainer">
				{postFetched ? (
					<PostForm
						formInitialValues={{
							post_title: postFetched ? postFetched.title : '',
							post_body: postFetched ? postFetched.body : ''
						}}
						handleFormSubmit={handleFormSubmit}
						formTitle="Edit Post"
						submitBtnText="Edit Post"
					/>
				) : (
					<div className="skeletonWrapper">
						<ContentLoader
							width="45vw"
							height="60vh"
							speed={1}
							{...pickSkeletonColor(themeName)}
							// viewBox="0 0 380 70"
						>
							{/* Only SVG shapes */}
							<rect x="0" y="0" width="100%" height="100%" rx="6" ry="6" />
						</ContentLoader>
					</div>
				)}
			</div>
		</div>
	);
};

export default EditPost;
